import React, { Component } from 'react';
import { Loading, Color, Navigation, HelmetEl } from './components';
// import Drift from "react-driftjs";
import { AppRoute } from './route'
import './App.css';


class App extends Component {
  render() {
    return (
      <div >
        {/* <Drift
          appId="3fuu3r232ikt"
          userId="3fuu3r232ikt"
          attributes={{ email: "arved.wonnek@yahoo.com", company: "PowerDEV" }}
        /> */}
        <HelmetEl />
        <Loading />
        <Color />
        <Navigation />
        <AppRoute />
      </div>
    );
  }
}

export default App;
